import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "homeModel" ]
  static values = {
    homeModelPrerenderedUrl: String
  }

  async connect() {
    var isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;
    if (!isMobile) {
      this.renderHomeModel()
    } else {
      const ctx = this.homeModelTarget.getContext('2d')

      const defImg = new Image()
      defImg.src = this.homeModelPrerenderedUrlValue
      defImg.onload = () => {
        ctx.drawImage(defImg, 0, 0)
      }
    }
  }

  async renderHomeModel() {
    const THREE = await import('three')
    const STLLoader = (await import('three-stl-loader')).default(THREE)


    const canvas = document.querySelector('#c')
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, preserveDrawingBuffer: true })

    const fov = 60
    const aspect = 1
    const near = 0.1
    const far = 5
    const camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
    camera.position.z = 2

    const scene = new THREE.Scene()
    const boxWidth = 1
    const boxHeight = 1
    const boxDepth = 1
    const geometry = new THREE.IcosahedronGeometry(1, 0)
    const material = new THREE.MeshPhongMaterial({ color: 0x462564 })
    const cube = new THREE.Mesh(geometry, material)

    // scene.add(cube)

    var loader = new STLLoader()
    loader.load('/model-binary-2.stl', function (geometry) {
      var material = new THREE.MeshPhongMaterial()
      const mesh = new THREE.Mesh(geometry, material)
      mesh.position.set(0, 0, 0)
      mesh.scale.set(.5, .5, .5)
      mesh.rotation.set(0, -(1/2) * (Math.PI / 2), 0)
      scene.add(mesh)

      const light = new THREE.DirectionalLight(0x462564, 1)
      light.position.set(-1, 2, 4)
      scene.add(light)

      const render = (time, delta) => {
        mesh.rotation.y = ((time / 1000) * 0.4) + (-(1 / 2) * (Math.PI / 2))

        renderer.render(scene, camera)
      }

      let clock = new THREE.Clock()
      let delta = 0
      let interval = 1 / 30

      const update = (time) => {
        requestAnimationFrame(update)
        delta += clock.getDelta()

        if (delta  > interval) {
          render(time, delta)
          delta = delta % interval
        }
      }

      update()
    })
  }
}
